import React from 'react';
import { Paper, Typography, Grid, List, ListItemButton, ListItemText, Box } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AnalyticsIcon from '@mui/icons-material/Analytics';

interface AIIdleSuggestionsProps {
  onSelect: (val: string) => void;
}

const CATEGORIES = [
  {
    title: 'Quick Actions',
    icon: <AutoAwesomeIcon fontSize="small" sx={{ color: '#7c3aed' }} />,
    items: ['Show delayed shipments', 'Today’s shipments', 'Pending deliveries', 'International shipments'],
  },
  {
    title: 'Carrier Based',
    icon: <BusinessCenterIcon fontSize="small" sx={{ color: '#3b82f6' }} />,
    items: ['FedEx shipments', 'Blue Dart shipments', 'DHL shipments'],
  },
  {
    title: 'Status Based',
    icon: <LocalShippingIcon fontSize="small" sx={{ color: '#10b981' }} />,
    items: ['Delivered shipments', 'In transit shipments', 'Cancelled shipments'],
  },
  {
    title: 'Analytical',
    icon: <AnalyticsIcon fontSize="small" sx={{ color: '#f59e0b' }} />,
    items: ['Shipments from Delhi', 'Shipments to Mumbai', 'High priority shipments', 'Shipments above 50kg'],
  },
];

export default function AIIdleSuggestions({ onSelect }: AIIdleSuggestionsProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        position: 'absolute',
        top: '100%',
        left: 0,
        width: '100%',
        zIndex: 10,
        mt: 1,
        p: 3,
        borderRadius: '16px',
        borderColor: '#e2e8f0',
        backgroundColor: '#ffffff',
        boxShadow: '0 10px 30px -10px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05)',
        boxSizing: 'border-box',
      }}
      onMouseDown={e => e.preventDefault()} // Prevents input from losing focus on click
    >
      <Grid container spacing={3}>
        {CATEGORIES.map(category => (
          <Grid item xs={12} sm={6} md={3} key={category.title}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              {category.icon}
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: '#475569',
                  textTransform: 'uppercase',
                  fontSize: '11px',
                  letterSpacing: '0.5px',
                }}
              >
                {category.title}
              </Typography>
            </Box>
            <List disablePadding>
              {category.items.map(item => (
                <ListItemButton
                  key={item}
                  onClick={() => onSelect(item)}
                  sx={{
                    py: 0.75,
                    px: 1,
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#f8fafc',
                      '& .MuiListItemText-primary': {
                        color: '#7c3aed',
                      },
                    },
                  }}
                >
                  <ListItemText
                    primary={item}
                    primaryTypographyProps={{
                      fontSize: '13px',
                      fontWeight: 500,
                      color: '#64748b',
                    }}
                  />
                </ListItemButton>
              ))}
            </List>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
